export const SPRITE_VERSION = '22b2d'
